module.exports = __webpack_public_path__ + "static/img/modal-question.34ba4547.png";